/* global moment */
import { $ } from '@situation/setdesign.util';

$(document).one('TicketCalendar.init', (e, TicketCalendar, $on) => {
    $on(TicketCalendar.FILTER_DEFAULTS, (defaults) => {
        defaults.update({
            // set to the $tc-theme-name sass variable
            theme: 'bloodlove-theme',
            'disable-default-analytics': true,
            fullcalendar: {
                prevIcon: '<svg class="icon icon-use"><use xlink:href="#icon-arrow"></use></svg>',
                nextIcon: '<svg class="icon icon-use"><use xlink:href="#icon-arrow"></use></svg>',
                headingClass: 'heading heading--large',
            },
            'selected-date-performances': {
                titleClass: 'heading heading--large',
                buttonLinkTextOverride:
                    'Select Seats <span class="icon icon-use"><svg><use xlink:href="#icon-arrow"></use></svg></span>',
                buttonClass: '',
            },
        });
    });

    $on('select-event', (event) => {
        if (TicketCalendar.vm && TicketCalendar.vm.isMobile) {
            // Remove active class from previously selected elements
            $('a[aria-label].active, td[data-date].active').removeClass('active');
            const mDate = moment(event.start._d);
            const isoDate = mDate.format('YYYY-MM-DD');
            const ariaLabel = mDate.format('MMMM Do YYYY');
            // Target the td
            const $targetTd = $(`td[data-date="${isoDate}"]`);
            $targetTd.addClass('active');
            // Target the a tag with the correct aria-label format
            const $targetDateLink = $(`a[aria-label="${ariaLabel}"]`);
            $targetDateLink.addClass('active');
        }
    });
});
